import React from "react";

export const Spinner = () => {
  const baseClassname = "spinner";

  return <div className={baseClassname}></div>;
};
